// @ts-strict-ignore

import TakeActionCard from './TakeActionCard';
import type TakeActionListProps from './TakeActionList.props';

const TakeActionList = ({
  takeActionItems,
  className
}: TakeActionListProps) => {
  if (takeActionItems.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {takeActionItems.map(({ blurb, verb, linkUrl, visibleUrl }) => (
        <div
          key={`${visibleUrl}--${verb}--${linkUrl}`}
          className="mb-12 flex w-full flex-col justify-between rounded-sm bg-gray-300 px-4 py-8 md:flex-row md:items-center"
        >
          <TakeActionCard blurb={blurb} verb={verb} linkUrl={linkUrl} />
        </div>
      ))}
    </div>
  );
};

export default TakeActionList;
